// returns an integer i with min <= i < max
function getRandomIntegerWithRange(min, max) {
    min = Number(min);
    max = Number(max);

    return Math.floor(Math.random() * (max-min)) + min;
    // if max shall be included, i.e. returns an integer i with min <= i <= max
    // return Math.floor(Math.random() * (max-min+1)) + min;

    /* keep for now, seemed to return an integer i with min <= i < max
    function random(min, max){
        return Math.floor(Math.random() * max) + min;
    }
    if(min<0){
        const rnd = Math.round(random(0, max/2));
        return rnd-(min*-1);
    }
    return random(min, max);
    */
}
function getRandomNumberWithRange(min, max){
    return Number(Math.random() * max) + min;
}
function getRandomIntegerWithinBitCount(bitCount, canBeNegative, subtractSignedBit){
    let min, max;
    min = 0;
    max = Math.pow(2, bitCount);


    if(canBeNegative){
        if(subtractSignedBit){
            max = max - 2;
        }
        //Subtract the signedRange from the random value
        //E.g. 8 bit = 256
        //8 bit signed = -127 to 127 (Sign bit)
        //Rnd 0,256: 50 - 127 = -77
        const signedRange = (max / 2);
        return getRandomIntegerWithRange(min, max)-signedRange;
    }
    return getRandomIntegerWithRange(min, max);
}
export {getRandomIntegerWithRange, getRandomNumberWithRange, getRandomIntegerWithinBitCount}